var _rect, _path, _path2, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanqueFinance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 250",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1E3D59",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#17294C",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFD700",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#FFA500",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "url(#bgGradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,200 Q100,150 200,180 T400,160",
    fill: "none",
    stroke: "url(#goldGradient)",
    strokeWidth: 2,
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,180 Q100,220 200,190 T400,200",
    fill: "none",
    stroke: "#4A90E2",
    strokeWidth: 2,
    opacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30, 90)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial Black, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontSize: 45,
    letterSpacing: 2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    dy: 0
  }, "BANQUE"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    dy: 45
  }, "FINANCE"))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55,
    width: 300,
    height: 3,
    fill: "url(#goldGradient)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial Black, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 90,
    fontSize: 15,
    letterSpacing: 3
  }, "\n        Machine Learning\n      "), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 110,
    fontSize: 15,
    letterSpacing: 3
  }, "\n        Industrialisation\n      ")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 5,
    height: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 5,
    height: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 5,
    height: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 5,
    height: 5,
    fill: "#FFFFFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(350, 200)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 5,
    height: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 5,
    height: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 30,
    width: 5,
    height: 5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 5,
    height: 5,
    fill: "#FFFFFF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 150)",
    stroke: "#4A90E2",
    strokeWidth: 1,
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 20,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 10,
    x2: 40,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 5,
    x2: 60,
    y2: 15
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanqueFinance);
export default __webpack_public_path__ + "static/media/banque-finance.49926013cf353c7353c49173e6a352b0.svg";
export { ForwardRef as ReactComponent };